import { render } from "./SeguradorasView.vue?vue&type=template&id=2133fc74"
import script from "./SeguradorasView.vue?vue&type=script&lang=js"
export * from "./SeguradorasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__